/**
 * Socket.io client singleton.
 * Call connect()/disconnect() from NotificationContext when the user logs in/out.
 */
import { io } from 'socket.io-client';
import { isServerConfigured } from './api/axios';

function getSocketURL() {
  // Check if a mobile server URL is configured
  const stored = localStorage.getItem('ictops_server_url');
  if (stored) {
    // Remove /api suffix to get the base server URL
    return stored.replace(/\/api\/?$/, '');
  }

  // Fall back to env variable or same-origin
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL.replace('/api', '');
  }

  // Empty string = same origin (works for web with CRA proxy/nginx)
  return '';
}

// Create once — not connected until connect() is called
const socket = io(getSocketURL(), {
  autoConnect:  false,
  withCredentials: true,       // send the httpOnly cookie on handshake
  transports:   ['websocket', 'polling'],
});

// Expose a method to update socket URL when server is configured at runtime
export function reconnectSocket() {
  const url = getSocketURL();
  if (socket.io) {
    socket.io.uri = url;
  }
}

export default socket;
